const axios = require('axios');
import { isNewNewsletterEnabled } from './featureFlagService';

async function subscribe(data) {
    const form = new FormData()
    for ( const key in data ) {
        form.append(key, data[key]);
    }
    const result = await axios.post('/BrendonCustomNewsletterSubscription/Subscribe', form);
    return result.data;
}

const newSubscribe = async (data) => { 
    const result = await axios.post('/newslettersubscription/register', {
        Email: data?.Email,
        EstimatedBirthDate: !data?.EstimatedBirthDate || data?.EstimatedBirthDate?.length === 0 ? '' : data.EstimatedBirthDate,
    });

    return {
        Hide: result.data?.IsSuccess,
        Result: result.data?.Message,
    };
}

export const Newsletter = {
    subscribe: isNewNewsletterEnabled() ? newSubscribe : subscribe,
};

export default Newsletter;
